import { render, staticRenderFns } from "./PT395MemberMyPageParts.vue?vue&type=template&id=6fd122d0&"
import script from "./PT395MemberMyPageParts.vue?vue&type=script&lang=js&"
export * from "./PT395MemberMyPageParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports